export function handleCloseSurveyOnCornerButton() {
  const headings = document.querySelectorAll("h2");

  const confirmationHeading = Array.from(headings).find((h) =>
    h.textContent?.includes("Obrigado por responder")
  );

  if (!confirmationHeading) return;

  const container = confirmationHeading.closest("div");
  if (!container) return;

  const cornerButton = container.querySelector("button");

  return cornerButton || null;
}
